import Loading from "components/Loading";
import Permission from "components/Permission";
import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { MODULE_STORAGE } from "shared/constants";
import PermissionDeniedPage from "components/PermissionDenied";

const Storage = React.lazy(
  () => import("containers/ProjectManagement/Storage")
);

function StorageRoute() {
  return (
    <Route
      path="storage"
      element={
        <Suspense fallback={<Loading loading />}>
          <Permission
            children={<Storage />}
            permissionDenied={<PermissionDeniedPage />}
            modules={[MODULE_STORAGE]}
          />
        </Suspense>
      }
    />
  );
}

export default StorageRoute;
